$( document ).ready(() => {
	var $helpfulLinksButton = $('#footer-helpful-links-button');

	$helpfulLinksButton.menuToggle();
});


// WEBPACK FOOTER //
// ./assets/js/components/layout/footer.js